export default __webpack_public_path__ + "static/media/confirmation.e8d82139.svg";